import React from 'react'
import { YhBox } from '@src/components/YhBox'
import { Button, Switch, Table } from 'antd'
import { useMenuModel } from '../menuModel'
import { ColumnsType } from 'antd/lib/table'
import { EditModeType } from '@src/types/FmsTypes'
import { IMdResourceDetail } from '../../resource/ResourceTypes'
import moment from 'moment'
import { resourceService } from '../../resource/ResourceService'
import { globalPrompt } from '@src/components/YhMessage'

const TableDict = () => {
  const {
    pgCfg,
    dataSource,
    selectedRowKeys,
    setSelectedRowKeys,
    setDrawerVisible,
    loadTableData,
    setResourceModel,
    setSelectedData,
  } = useMenuModel()

  const onCheckMode = (mode: EditModeType) => {
    if (selectedRowKeys) {
      setDrawerVisible(true)
      setResourceModel(mode)
    }
  }

  const action = <>
    <Button type="link" shape="round" onClick={() => onCheckMode('add')}>新增</Button>
    <Button type="link" disabled={selectedRowKeys.length === 0} shape="round" onClick={() => onCheckMode('edit')}>编辑</Button>
  </>

  const columns: ColumnsType<IMdResourceDetail> = [
    {
      align: 'center',
      title: '序号',
      width: 60,
      render: (v, r, i) => i + 1
    },
    {
      align: "center",
      title: '资源编号',
      width: 200,
      dataIndex: 'code',
    },
    {
      align: "center",
      title: '资源名称',
      width: 200,
      dataIndex: 'name',
    },
    {
      align: "center",
      title: '创建人',
      width: 150,
      dataIndex: 'createUser',
    },
    {
      align: "center",
      title: '创建时间',
      width: 200,
      dataIndex: 'createTime',
      render: (dateArray) => dateArray ? moment([
        dateArray[0],
        dateArray[1] - 1, // 将月份减1，使5→4（代表5月）
        dateArray[2],
        dateArray[3],
        dateArray[4],
        dateArray[5]
      ]).format("YYYY-MM-DD HH:mm:ss") : ''
    },
    {
      align: "center",
      title: '资源描述',
      width: 150,
      dataIndex: 'note',
    },
    {
      align: "center",
      title: '操作',
      width: 120,
      dataIndex: 'status',
      render: (value, record) => {
        return (
          <Switch checkedChildren="开启" unCheckedChildren="关闭" checked={value === 0} onChange={(e) => onChange(e, record)} />
        )
      }
    },
    {
      align: "center",
      title: '状态',
      dataIndex: 'status',
      width: 120,
      render: (v) => v === 0 ? "启用" : "禁用"
    },
  ];

  // 修改资源状态
  const onChange = async (checked: boolean, row: IMdResourceDetail) => {

    try {
      const params = {
        ...row,
        status: checked ? 0 : 1,
      }
      const updateRet = await resourceService.update(params);
      if (updateRet.success) {
        await globalPrompt("message", { type: "success", text: '修改成功!' });
        setSelectedRowKeys([])
        setSelectedData(undefined)
        loadTableData({ pageNum: 1 })
      } else {
        await globalPrompt("message", { type: "error", text: "修改失败!" + updateRet.retMsg });
      }
    } catch (error) {
      console.log("失败!");
    }
  }

  return (
    <YhBox
      action={action}
      style={{ height: 'calc(100% - 80px)' }}
    >

      <Table
        style={{ cursor: "pointer" }}
        rowSelection={{
          type: "radio",
          onChange: (selectedRowKeys: React.Key[], selectedRows: IMdResourceDetail[]) => {
            setSelectedRowKeys(selectedRowKeys);
            setSelectedData(selectedRows[0])
          },
          selectedRowKeys
        }}
        columns={columns}
        dataSource={dataSource}
        pagination={{
          ...pgCfg,
          position: ["bottomCenter"],
          onChange: (pageNum, pageSize) => {
            loadTableData({ pageNum, pageSize }).then();
          }
        }}
        onRow={record => {
          return {
            onClick: event => {
              if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                setSelectedRowKeys([]);
                setSelectedData(undefined)
              } else {
                setSelectedRowKeys([record.key]);
                setSelectedData(record)
              }
            },
          };
        }}
      />

    </YhBox>
  )
}

export default TableDict;